import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Grid, TextField, InputAdornment } from "@mui/material"
import { AccordionSeeker, IconSeeker } from "@ui-seeker/core"

import { searchText } from "../@signals"
import SkuCandidatesMarketFilter from "./MarketFilter"
import SkuCandidatesSitesFilter from "./SitesFilter"
import SkuCandidatesBrandsFilter from "./BrandsFilter"
import SkuCandidatesFiltersFooter from "./Footer"


export default function SkuCandidatesFilters() {
    const isOpen = useSignal(true)

    return <AccordionSeeker
        title="Filters"
        TransitionProps={{ unmountOnExit: false }}
        expanded={isOpen.value}
        onChange={() => isOpen.value = !isOpen.value}
        footerActions={<SkuCandidatesFiltersFooter />}
    >
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
                <SkuCandidatesMarketFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <SkuCandidatesSitesFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <SkuCandidatesBrandsFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField
                    fullWidth
                    size="small"
                    placeholder="Filter by text"
                    value={searchText.value}
                    onChange={(e) => searchText.value = e.target.value}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <IconSeeker icon="search" sx={{ fontSize: 16, color: '#9ca3af' }} />
                            </InputAdornment>
                        )
                    }}
                />
            </Grid>
        </Grid>
    </AccordionSeeker>
}
